function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Subtract Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 144",
    width: 16,
    height: 16,
    rx: 2,
    style: {
      fill: "#ffa539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 171",
    transform: "translate(4 8)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round"
    },
    d: "M0 0h7"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractButton);
export default __webpack_public_path__ + "static/media/SubtractButton.a4ba19bf0064bd3c4f5ed1b2b10642d0.svg";
export { ForwardRef as ReactComponent };